<template>
  <div class="w-full h-full py-4 lg:py-6 rounded-md">
    <div
      class="w-full flex 2xl:gap-5 justify-between lg:justify-end py-2 gap-2 lg:gap-4"
    >
      <div class="flex items-center">
        <form
          @submit.prevent="searchStudent"
          class="flex gap-2 lg:gap-4 w-full"
        >
          <input
            type="text"
            name="student_search"
            id="student_search"
            v-model="student_search"
            placeholder="Search by name"
            class="rounded-lg w-[70%] lg:w-[240px] bg-primary2"
          />
          <button type="submit" class="btn text-sm px-4 py-2 rounded-lg">
            Search
          </button>
        </form>
      </div>
      <button
        @click="addRecipient = true"
        class="btn text-sm px-4 py-2 rounded-lg"
      >
        Add+
      </button>
    </div>
    <div v-if="loader == false">
      <div v-if="recipientList.length > 0" class="w-full overflow-x-scroll">
        <table class="min-w-full bg-primary2 shadow-md">
          <thead class="bg-primary border-b text-start sticky top-0 text">
            <tr class="text-left whitespace-nowrap">
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                S.No
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                First Name
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Last Name
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Email
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="recipientList.length <= 0">
              <td></td>
              <td class="px-4 py-2 xl:px-6 xl:py-4 text-left">{{ message }}</td>
            </tr>
            <tr
              v-else
              class="text-left border-b whitespace-nowrap"
              v-for="(recipient, index) in recipientList"
              :key="index"
            >
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ index + (this.current_page_number - 1) * 20 + 1 }}
              </td>

              <!-- <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p>{{ recipient.first_name }}</p>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ recipient.last_name }}
              </td> -->
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p>{{ recipient.first_name }}</p>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <span v-if="recipient.last_name">
                  {{ recipient.last_name }}
                </span>
                <span v-else>-</span>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">{{ recipient.email }}</td>
              <td class="whitespace-nowrap px-4 py-2 xl:px-6 xl:py-4 relative">
                <div class="inline-flex items-center justify-center">
                  <button
                    @click="toggleEdit(recipient.id)"
                    class="size-8 rounded-full mt-1 p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="size-4.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute -left-[110px] top-4 w-[130px] z-50"
                    v-show="popupId === recipient.id"
                  >
                    <div
                      class="popper-box rounded-md border border-slate-150 bg-white py-0 font-inter dark:border-navy-500 dark:bg-navy-700"
                    >
                      <ul>
                        <li
                          @click="
                            editRecipientList(recipient.id);
                            editstudentaginStatus = true;
                          "
                        >
                          <p
                            class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                          >
                            Edit
                          </p>
                        </li>
                        <!-- <li @click="deleteCampaign(campaigns.id, campaigns.name)">
                      <p
                        class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                      >
                        Delete
                      </p>
                    </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="bg-primary border-b text">
            <tr class="">
              <td colspan="5" class="px-4 py-2 xl:px-6 xl:py-4">
                <div class="flex justify-between items-center w-full">
                  <h2 class="">
                    Showing {{ first_value }} to
                    {{ last_value }}
                  </h2>
                  <h2 class="">
                    Page {{ total_std_list.current_page_number }} of
                    {{ total_std_list.total_pages }}
                  </h2>
                  <div class="flex gap-4">
                    <button
                      v-if="stduent_prev"
                      @click="prevStudent"
                      class="btn px-2 py-1 rounded-md"
                    >
                      prev
                    </button>
                    <button
                      v-if="stduent_next"
                      @click="nextStudent"
                      class="btn px-2 py-1 rounded-md"
                    >
                      next
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else class="" style="height: calc(100vh - 80px)">
        <div class="flex flex-col justify-center items-center h-full">
          <img
            :src="no_data"
            class="w-full h-[500px] object-contain"
            alt=""
            srcset=""
          />
          <h1 class="text-black text-lg">NO DATA FOUND</h1>
        </div>
      </div>
    </div>
    <div
      v-if="addRecipient == true"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="flex justify-between w-full">
          <h2 class="text-xl font-semibold">Add Student</h2>
          <span
            @click="addRecipient = false"
            class="font-semibold text-lg hover:text-red-700 cursor-pointer"
            >x</span
          >
        </div>
        <form
          action=""
          @submit.prevent="recipientCreate"
          class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
        >
          <div class="flex flex-col text-start">
            <label for="fname">First Name</label>
            <input
              v-model="fname"
              id="fname"
              type="text"
              class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
            />
          </div>
          <div class="flex flex-col text-start">
            <label for="lname">Last Name</label>
            <input
              v-model="lname"
              id="lname"
              type="text"
              class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
            />
          </div>
          <div class="flex flex-col text-start">
            <label for="email">Email</label>
            <input
              v-model="email"
              id="email"
              type="text"
              class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
            />
          </div>
          <div class="flex justify-center pt-3">
            <button type="submit" class="w-40 px-4 py-2 btn rounded-md">
              Submit
            </button>
          </div>
        </form>
        <div class="flex items-center justify-center pt-3 w-full">
          <div class="w-full border border-gray-400 h-0"></div>
          <div class="px-3 text-black">or</div>
          <div class="w-full border border-gray-400 h-0"></div>
        </div>
        <!-- <form
          @submit.prevent="recipientBulkUpload"
          class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
        > -->
        <div class="flex flex-col gap-2 lg:gap-3 justify-start w-full">
          <h1 class="text-lg">Bulk Upload</h1>

          <div class="flex justify-between items-center">
            <div class="flex flex-col gap-3 text-start w-full">
              <label for="updatedName"
                >Upload the student file (*xlsx file only)</label
              >
              <input
                type="file"
                name=""
                @change="recipientBulkUpload"
                id="recipient_upload"
                accept=".xlsx, .xls, .csv"
                class="bg-white focus:outline-none"
                required
              />
            </div>
            <div class="w-[20%] flex justify-center items-center">
              <a
                :href="file_download"
                download
                class="w-full flex justify-center tooltip"
              >
                <img
                  :src="download_file"
                  alt="download file"
                  class="w-5 h-5 object-contain"
                />
                <span class="tooltiptext text-xs"> Sample File</span>
              </a>
            </div>
          </div>
        </div>

        <!-- </form> -->
      </div>
    </div>
    <!-- edit recipient List   -->
    <div
      v-if="editRecipientListStatus == true"
      class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
    >
      <div
        class="bg-white p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="p-8 w-full text-lg h-full">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold text-black">Update Student</h2>
            <span
              @click="editRecipientListStatus = false"
              class="font-semibold text-lg hover:text-red-700 cursor-pointer"
              >x</span
            >
          </div>
          <form
            action=""
            @submit.prevent="updateRecipientList"
            class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
          >
            <div class="flex flex-col text-start">
              <label for="update_fname">First Name</label>
              <input
                v-model="update_fname"
                id="update_fname"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="update_lname">Last Name</label>
              <input
                v-model="update_lname"
                id="update_lname"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="update_email">Email</label>
              <input
                v-model="update_email"
                id="update_email"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <!-- <div class="flex flex-col text-start">
              <label for="updatedName">Campaign List</label>
              <select
                class="border focus:outline-none rounded-md px-3 py-2 w-full bg-white"
                name="recipientList"
                id="recipientList"
                v-model="updateRecipientLists.campaign"
              >
                <option value="" disabled selected>Update Campaign</option>
                <option
                  v-for="recipients in campaignList"
                  :key="recipients.id"
                  :value="recipients.id"
                >
                  {{ recipients.name }}
                </option>
              </select>
            </div>
            <div class="flex flex-col text-start">
              <label for="updatedEmail">Recipient</label>
              <select
                class="border focus:outline-none rounded-md px-3 py-2 w-full bg-white"
                name="recipientList"
                id="recipientList"
                v-model="updateRecipientLists.recipient"
              >
                <option value="" disabled selected>Update Recipient</option>
                <option
                  v-for="recipients in individualList"
                  :key="recipients.id"
                  :value="recipients.id"
                >
                  {{ recipients.email }}
                </option>
              </select>
            </div> -->

            <div class="flex justify-center pt-3">
              <button
                type="submit"
                class="py-2 w-40 rounded-lg bg-gradient-to-r from-blue-500 to-[#2563EB] text-white hover:bg-gradient-to-l hover:from-blue-500 hover:to-[#2563EB]"
              >
                Submit
              </button>
            </div>
          </form>
          <!-- <div v-if="updateValue" class="py-3">
            <p class="text-lg font-semibold">{{ updateValue }}</p>
          </div> -->
        </div>
      </div>
    </div>
    <div
      v-if="flashMessage"
      class="fixed max-w-[420px] w-full bg-white border border-gray-200 shadow-xl bottom-2 right-2 p-6 rounded-md z-[500]"
    >
      <p>
        Message : {{ this.bulkUploadStatus.message }} <br />
        Total Recipient : {{ this.bulkUploadStatus.total_recipient }} <br />
        Created Recipient : {{ this.bulkUploadStatus.created_recipient }}
        <br />
        Skipped Recipient : {{ this.bulkUploadStatus.skipped_recipient }}
        <br />
      </p>
    </div>
    <!-- loader start -->
    <div v-if="loader" class="flex flex-col justify-center items-center">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      Loading...
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "recipientView",
  data() {
    return {
      loader: false,
      addRecipient: false,
      editRecipientListStatus: false,
      recipientList: [],
      updateRecipient: [],
      popupId: "",
      fname: "",
      lname: "",
      email: "",
      update_fname: "",
      update_lname: "",
      update_email: "",
      message: "",
      recipient_id: "",
      isLoading: false,
      bulkUploadStatus: {
        message: "",
        total_recipient: "",
        created_recipient: "",
        skipped_recipient: "",
      },
      flashMessage: false,
      currentPage: 1,
      perPage: 10,
      next: require(`${process.env.VUE_APP_NEXT}`),
      back: require(`${process.env.VUE_APP_BACK}`),
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      download_file: require(`${process.env.VUE_APP_DOWNLOAD_FILE}`),
      file_download: `${process.env.VUE_APP_FILE_DOWNLOAD}`,
      student_search: "",
      total_std_list: "",
      stduent_next: "",
      lead_prev: "",
      current_page_number: "",
      total_pages: "",
      first_value: 1,
      stduent_prev: "",
      stduent_next: "",
      last_value: 20,
    };
  },
  async created() {
    this.loader = true;
    await this.getRecipient();
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  methods: {
    async getRecipient() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/recipient/list/?Key=${this.userInfo.data.token}`,
        )
        .then((resp) => {
          console.log("resp lead 1550", resp);
          if (resp.data.data.status == 200) {
            this.total_std_list = resp.data;
            this.stduent_next = resp.data.next;
            this.stduent_prev = resp.data.previous;
            this.current_page_number = resp.data.current_page_number;
            this.total_pages = resp.data.total_pages;
            this.recipientList = resp.data.data.data;
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          } else if (resp.data.data.status == 400) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("Error fetching leads:", error);
        });
    },
    async nextStudent() {
      await axios
        .get(`${this.stduent_next}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.recipientList = resp.data.data.data;
          this.stduent_next = resp.data.next;
          this.stduent_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = this.current_page_number * 20;
          this.total_pages = resp.data.total_pages;
          this.loader = false;
          if (this.stduent_next === null) {
            this.last_value = resp.data.count;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // previous stduent list
    async prevStudent() {
      await axios
        .get(`${this.stduent_prev}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.recipientList = resp.data.data.data;
          this.stduent_next = resp.data.next;
          this.stduent_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.total_pages = resp.data.total_pages;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          // this.last_value = (this.last_value / 20 - 1) * 20;
          this.loader = false;
          if (this.stduent_next === null) {
            this.last_value = resp.data.count;
          } else {
            this.last_value = this.current_page_number * 20;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // async getRecipient() {
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_API}/recipient/list/?Key=${this.userInfo.data.token}`
    //     )
    //     .then((resp) => {
    //       console.log("resp 497", resp);
    //       if (resp.data.data.status == 200) {
    //         this.recipientList = resp.data.data.data;
    //         this.message = resp.data.data.message;
    //         this.total_std_list = resp.data;
    //         this.stduent_next = resp.data.next;
    //         this.stduent_prev = resp.data.previous;
    //         this.current_page_number = resp.data.current_page_number;
    //         this.total_pages = resp.data.total_pages;
    //         setTimeout(() => {
    //           this.loader = false;
    //         }, 1000);
    //       } else if (resp.data.data.status == 400) {
    //         setTimeout(() => {
    //           this.loader = false;
    //         }, 1000);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log("error ", err);
    //     });
    // },
    // async nextStudent() {
    //   await axios
    //     .get(`${this.stduent_next}`)
    //     .then((resp) => {
    //       console.log("resp 523", resp);
    //       if (resp.data.data.status == 200) {
    //         this.recipientList = resp.data.data.data;
    //         this.message = resp.data.data.message;
    //         this.total_std_list = resp.data;
    //         this.stduent_next = resp.data.next;
    //         this.stduent_prev = resp.data.previous;
    //         console.log("this.stduent_prev", this.stduent_prev);
    //         this.current_page_number = resp.data.current_page_number;
    //         this.first_value = (this.current_page_number - 1) * 20 + 1;
    //         this.last_value = this.current_page_number * 20;
    //         this.total_pages = resp.data.total_pages;
    //         if (this.stduent_next === null) {
    //           this.last_value = resp.data.count;
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    // previous stduent list
    // async prevStudent() {
    //   console.log(
    //     "sghdfhsavasvfvytwevfuyevfsdhvbfhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"
    //   );
    //   await axios
    //     .get(`${this.stduent_prev}`)
    //     .then((resp) => {
    //       console.log("resp prev 555", resp);
    //       if (resp.data.data.status == 200) {
    //         this.total_std_list = resp.data;
    //         this.recipientList = resp.data.data.data;
    //         this.student_next = resp.data.next;
    //         this.stduent_prev = resp.data.previous;
    //         this.current_page_number = resp.data.current_page_number;
    //         this.total_pages = resp.data.total_pages;
    //         this.first_value = (this.current_page_number - 1) * 20 + 1;
    //         this.loader = false;
    //         if (this.stduent_next === null) {
    //           this.last_value = resp.data.count;
    //         } else {
    //           this.last_value = this.current_page_number * 20;
    //         }
    //         this.loader = false;
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    searchStudent() {
      axios
        .get(
          `${process.env.VUE_APP_API}/recipient/list/?search=${this.student_search}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.recipientList = resp.data.data.data;
            this.message = resp.data.data.message;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    editRecipientList(id) {
      this.recipient_id = id;
      this.editRecipientListStatus = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/recipient/list/?id=${id}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.updateRecipient = resp.data.data.data;
            this.update_fname = this.updateRecipient[0].first_name;
            this.update_lname = this.updateRecipient[0].last_name;
            this.update_email = this.updateRecipient[0].email;
            this.message = resp.data.data.message;
            this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    updateRecipientList() {
      const recipientData = {
        first_name: this.update_fname,
        last_name: this.update_lname,
        email: this.update_email,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/recipient/update-destroy/${this.recipient_id}/?Key=${this.userInfo.data.token}`,
          recipientData
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.editRecipientListStatus = false;
            this.getRecipient();
            // this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    recipientCreate() {
      const recipientData = {
        first_name: this.fname,
        last_name: this.lname,
        email: this.email,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/recipient-create/post/?Key=${this.userInfo.data.token}`,
          recipientData
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.addRecipient = false;
            this.getRecipient();
            this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    toggleEdit(id) {
      if (this.popupId === id) {
        this.popupId = null;
      } else {
        this.popupId = id;
      }
    },
    recipientBulkUpload(event) {
      const file = event.target.files[0];
      let formData = new FormData();
      formData.append("file", file);

      axios
        .post(
          `${process.env.VUE_APP_API}/recipient/bulk-upload/?Key=${this.userInfo.data.token}`,
          formData
        )
        .then((response) => {
          this.flashMessage = true;
          this.bulkUploadStatus.message = response.data.message;
          this.bulkUploadStatus.created_recipient =
            response.data.created_recipient;
          this.bulkUploadStatus.skipped_recipient =
            response.data.skipped_recipient;
          this.bulkUploadStatus.total_recipient = response.data.total_recipient;
          this.addRecipient = false;
          this.getRecipient();
          setTimeout(() => {
            this.flashMessage = false;
          }, 6000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // YYYY-MM-DDThh:mm
    formatUpdateDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },
    formatDate(dateString) {
      if (!dateString) return "Invalid Date";
      const date = new Date(dateString);

      const dateOptions = { month: "short", day: "2-digit", year: "numeric" };
      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      };

      const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
      const formattedTime = date.toLocaleTimeString("en-IN", timeOptions);

      return `${formattedDate} / ${formattedTime}`;
    },
    // pagenation
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<style></style>
